/**
 * useCanManageProcessProcedures — czy user widzi Ustawienia → „Procedury SQL" → zakładka „Procesy"
 * (katalog procedur SQL podpinanych do przejść procesu, ADR-0074).
 *
 * Warunek: `isSuperUser` LUB permission `processes.procedures.manage` (dziś zawsze `false`
 * dla zwykłego usera — `GET /api/auth/me` nie zwraca jeszcze realnych uprawnień, patrz
 * `docs/architecture/AUTH.md` — ale sprawdzamy od razu, żeby nie trzeba było wracać do
 * trzech miejsc gdy backend zacznie je zwracać, mirror `useCanManageProcessDefinitions`),
 * ORAZ aktywna subskrypcja modułu `processes`.
 *
 * Backend gate (jedno uprawnienie na wszystko — podgląd/CRUD/test/restore):
 * `apps/api/app/api/processes/procedures/route.ts` (`canTenantWide(ctx, 'processes.procedures.manage')`).
 */
import { type TenantMeResponse, useTenantAuth } from '@/contexts/TenantAuthContext';

/** Czysta wersja (bez kontekstu) — dla miejsc, które mają `me` z opcjonalnego kontekstu. */
export function canManageProcessProcedures(me: TenantMeResponse | null | undefined): boolean {
  const isSuperUser = me?.user.isSuperUser === true;
  const hasPermission = me?.permissions.includes('processes.procedures.manage') ?? false;
  const isModuleActive = me?.modules.some((m) => m.code === 'processes') ?? false;
  return (isSuperUser || hasPermission) && isModuleActive;
}

export function useCanManageProcessProcedures(): boolean {
  const { me } = useTenantAuth();
  return canManageProcessProcedures(me);
}
